import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const HiddenInput = styled.input`
    display: none;
`

export const DropZone = styled.div`
    border: 2px dashed #d1d5db;
    border-radius: 12px;
    padding: 2.5rem 1.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
    background: #f9fafb;

    &:hover {
        border-color: ${orange};
        background: #fef3e2;
    }
`

export const DropZoneIcon = styled.div`
    width: 3rem;
    height: 3rem;
    color: #9ca3af;

    svg {
        width: 100%;
        height: 100%;
    }
`

export const DropZoneText = styled.p`
    margin: 0;
    font-size: 0.9375rem;
    color: #6b7280;
    text-align: center;
    line-height: 1.6;

    strong {
        color: ${orange};
    }

    span {
        font-size: 0.8125rem;
        color: #9ca3af;
    }
`

export const CropWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.875rem;
`

export const CropArea = styled.div`
    position: relative;
    width: 100%;
    height: 18rem;
    border-radius: 12px;
    overflow: hidden;
    background: #1a1a1a;
`

export const CropHint = styled.p`
    margin: 0;
    font-size: 0.75rem;
    color: #9ca3af;
    text-align: center;
`

export const ZoomSliderRow = styled.div`
    display: flex;
    align-items: center;
    gap: 0.75rem;
`

export const ZoomSliderLabel = styled.span`
    font-size: 0.8125rem;
    color: #6b7280;
    font-weight: 500;
    flex-shrink: 0;
`

export const ZoomSlider = styled.input`
    flex: 1;
    -webkit-appearance: none;
    height: 4px;
    border-radius: 2px;
    background: #e5e7eb;
    outline: none;
    cursor: pointer;

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: ${orange};
        cursor: pointer;
        transition: transform 0.15s;

        &:hover {
            transform: scale(1.2);
        }
    }

    &::-moz-range-thumb {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: ${orange};
        cursor: pointer;
        border: none;
    }
`

export const CropActions = styled.div`
    display: flex;
    gap: 0.75rem;
    margin-top: 1rem;
    justify-content: flex-end;
`

export const CropButton = styled.button<{ $variant: 'primary' | 'secondary' }>`
    padding: 0.625rem 1.25rem;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid ${({ $variant }) => ($variant === 'primary' ? orange : '#d1d5db')};
    background: ${({ $variant }) => ($variant === 'primary' ? orange : 'white')};
    color: ${({ $variant }) => ($variant === 'primary' ? 'white' : '#374151')};

    &:hover:not(:disabled) {
        opacity: 0.9;
        transform: translateY(-1px);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`
